module.exports = __webpack_public_path__ + "img/10.3129a51c.jpeg";